module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M26.874 9.308H11.816c-.924 0-1.672.748-1.672 1.672v16.73a1.674 1.674 0 0 0 3.346 0V12.652h13.384a1.671 1.671 0 1 0 0-3.344z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/fda-highlight.js
// module id = 1142
// module chunks = 14